import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Flex, Input, Text, Box, VStack } from '@chakra-ui/react';
import { HiUpload } from 'react-icons/hi';

import { shipStationSalesOrderNumberMappingApi } from 'features/third-party-integrations/third-party-integrations.api';
import { useColors } from './colors';

const SalesOrderNumberMapping = ({ embedded = false }) => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);
  const { textColor, borderColor } = useColors();

  const { shipStationSalesOrderNumberMappingStatus } = useSelector(
    (state) => state.thirdPartyIntegrations,
  );

  const isSubmitting = shipStationSalesOrderNumberMappingStatus === 'pending';
  const selectedFileName = useMemo(() => selectedFile?.name || '', [selectedFile]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleMapToShipStation = () => {
    if (!selectedFile || isSubmitting) return;
    dispatch(shipStationSalesOrderNumberMappingApi(selectedFile));
  };

  if (embedded) {
    return (
      <VStack align="stretch" spacing={3}>
        <Flex
          direction={{ base: 'column', sm: 'row' }}
          gap={4}
          align={{ base: 'stretch', sm: 'center' }}
        >
          <Input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            flex={1}
            size="md"
            py={2}
            bg="white"
            _dark={{ bg: 'navy.800' }}
            borderColor={borderColor}
          />
          <Button
            colorScheme="blue"
            size="md"
            leftIcon={<HiUpload />}
            onClick={handleMapToShipStation}
            isLoading={isSubmitting}
            loadingText="Mapping…"
            isDisabled={!selectedFile || isSubmitting}
            flexShrink={0}
          >
            Map to ShipStation
          </Button>
        </Flex>
        {selectedFileName && (
          <Text fontSize="sm" color="gray.600">
            Selected: {selectedFileName}
          </Text>
        )}
      </VStack>
    );
  }

  return (
    <Box mt={6} p={4} border="1px solid" borderColor={borderColor} borderRadius="md">
      <Text fontSize="lg" fontWeight="bold" mb={1} color={textColor}>
        ShipStation sales order number mapping
      </Text>
      <Text fontSize="sm" color="gray.500" mb={4}>
        Upload Excel file with column A as Order Number and column D as Sales Order #.
      </Text>
      <Flex gap={3} alignItems="center" flexWrap="wrap">
        <Input
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileChange}
          p={1}
          maxW="500px"
          bg="white"
        />
        <Button
          colorScheme="blue"
          onClick={handleMapToShipStation}
          isLoading={isSubmitting}
          loadingText="Mapping…"
          isDisabled={!selectedFile || isSubmitting}
        >
          Map to ShipStation
        </Button>
      </Flex>
      {selectedFileName && (
        <Text mt={3} fontSize="sm" color="gray.600">
          Selected: {selectedFileName}
        </Text>
      )}
    </Box>
  );
};

export default SalesOrderNumberMapping;
